import ForgotPassword from '../components/forgotPassword';
import React from "react";

function ForgotPasswordContainer() {
  return (<ForgotPassword />);
}

export default ForgotPasswordContainer;
